export const allETFsQueryMock = {
    allExchangeTradedFunds: [
        {
            ticker: 'TCHP',
            name: 'T. Rowe Price ETF Test',
            inceptionDate: '2020-08-04T04:00:00Z',
            grossExpenseRatio: 0, // 0.57,
            publicOfferingDate: '2020-08-05T04:00:00Z',
            netExpenseRatio: 0, // 0.57,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -37.82,
                            navOneYearReturn: -37.88,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -17.58,
                            navSinceInceptionAnnualizedReturn: -7.72,
                            marketPriceQuarterlyYtdReturn: -37.82,
                            marketPriceOneYearReturn: -37.82,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -17.5,
                            marketPriceSinceInceptionAnnualizedReturn: -7.68,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 24.03,
                navPriceChange: -0.03,
                navPricePercentChange: -0.124688,
                closingPrice: 24.03,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TDVG',
            name: 'T. Rowe Price Dividend Growth ETF ',
            inceptionDate: '2020-08-04T04:00:00Z',
            grossExpenseRatio: 0.5,
            publicOfferingDate: '2020-08-05T04:00:00Z',
            netExpenseRatio: 0.5,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -10.16,
                            navOneYearReturn: -10.02,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: 28.8,
                            navSinceInceptionAnnualizedReturn: 11.09,
                            marketPriceQuarterlyYtdReturn: -10.16,
                            marketPriceOneYearReturn: -10.16,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: 28.71,
                            marketPriceSinceInceptionAnnualizedReturn: 11.06,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 31.83,
                navPriceChange: -0.21,
                navPricePercentChange: -0.655431,
                closingPrice: 31.83,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TEQI',
            name: 'T. Rowe Price Equity Income ETF',
            inceptionDate: '2020-08-04T04:00:00Z',
            grossExpenseRatio: 0.54,
            publicOfferingDate: '2020-08-05T04:00:00Z',
            netExpenseRatio: 0.54,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -3.33,
                            navOneYearReturn: 0, // -3.25,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: 45.38,
                            navSinceInceptionAnnualizedReturn: 16.82,
                            marketPriceQuarterlyYtdReturn: 0, // -3.33,
                            marketPriceOneYearReturn: -3.33,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: 45.29,
                            marketPriceSinceInceptionAnnualizedReturn: 16.79,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 33.45,
                navPriceChange: -0.28,
                navPricePercentChange: -0.830122,
                closingPrice: 33.43,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TGRW',
            name: 'T. Rowe Price Growth Stock ETF',
            inceptionDate: '2020-08-04T04:00:00Z',
            grossExpenseRatio: 0.52,
            publicOfferingDate: '2020-08-05T04:00:00Z',
            netExpenseRatio: 0.52,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -38.43,
                            navOneYearReturn: -38.39,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -17.29,
                            navSinceInceptionAnnualizedReturn: -7.58,
                            marketPriceQuarterlyYtdReturn: -38.43,
                            marketPriceOneYearReturn: -38.43,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -17.29,
                            marketPriceSinceInceptionAnnualizedReturn: -7.58,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 24.06,
                navPriceChange: -0.06,
                navPricePercentChange: -0.248756,
                closingPrice: 24.06,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TSPA',
            name: 'T. Rowe Price U.S. Equity Research ETF',
            inceptionDate: '2021-06-08T04:00:00Z',
            grossExpenseRatio: 0.34,
            publicOfferingDate: '2021-06-09T04:00:00Z',
            netExpenseRatio: 0.34,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -18.69,
                            navOneYearReturn: -18.64,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -7.64,
                            navSinceInceptionAnnualizedReturn: -4.95,
                            marketPriceQuarterlyYtdReturn: -18.69,
                            marketPriceOneYearReturn: -18.69,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -7.65,
                            marketPriceSinceInceptionAnnualizedReturn: -4.95,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 24.53,
                navPriceChange: -0.14,
                navPricePercentChange: -0.567491,
                closingPrice: 24.53,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TOTR',
            name: 'T. Rowe Price Total Return ETF',
            inceptionDate: '2021-09-28T04:00:00Z',
            grossExpenseRatio: 0.31,
            publicOfferingDate: '2021-09-29T04:00:00Z',
            netExpenseRatio: 0.31,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null, // '2022-12-31T00:00:00Z',
                    fundPerformance: [],
                    //     {
                    //         performanceType: 'Net',
                    //         navQuarterlyYtdReturn: -15.89,
                    //         navOneYearReturn: -15.81,
                    //         navThreeYearReturn: null,
                    //         navFiveYearReturn: null,
                    //         navTenYearReturn: null,
                    //         navSinceInceptionReturn: -15.8,
                    //         navSinceInceptionAnnualizedReturn: -12.79,
                    //         marketPriceQuarterlyYtdReturn: -15.89,
                    //         marketPriceOneYearReturn: -15.89,
                    //         marketPriceThreeYearReturn: null,
                    //         marketPriceFiveYearReturn: null,
                    //         marketPriceTenYearReturn: null,
                    //         marketPriceSinceInceptionReturn: -15.74,
                    //         marketPriceSinceInceptionAnnualizedReturn: -12.74,
                    //         __typename: 'ETFPerformance'
                    //     }
                    // ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 42.04,
                navPriceChange: 0.19,
                navPricePercentChange: 0.454002,
                closingPrice: 42.09,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TAGG',
            name: 'T. Rowe Price QM U.S. Bond ETF',
            inceptionDate: '2021-09-28T04:00:00Z',
            grossExpenseRatio: 0.08,
            publicOfferingDate: '2021-09-29T04:00:00Z',
            netExpenseRatio: 0.08,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Gross',
                            navQuarterlyYtdReturn: null,
                            navOneYearReturn: -13.35,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -13.45,
                            navSinceInceptionAnnualizedReturn: -10.85,
                            marketPriceQuarterlyYtdReturn: null,
                            marketPriceOneYearReturn: null,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: null,
                            marketPriceSinceInceptionAnnualizedReturn: null,
                            __typename: 'ETFPerformance'
                        },
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -13.67,
                            navOneYearReturn: -13.42,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -13.53,
                            navSinceInceptionAnnualizedReturn: -10.93,
                            marketPriceQuarterlyYtdReturn: -13.67,
                            marketPriceOneYearReturn: -13.67,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -13.66,
                            marketPriceSinceInceptionAnnualizedReturn: -11.03,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 43.58,
                navPriceChange: 0.22,
                navPricePercentChange: 0.50738,
                closingPrice: 43.6,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TBUX',
            name: 'T. Rowe Price Ultra Short-Term Bond ETF',
            inceptionDate: '2021-09-28T04:00:00Z',
            grossExpenseRatio: 0.17,
            publicOfferingDate: '2021-09-29T04:00:00Z',
            netExpenseRatio: 0.17,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -0.12,
                            navOneYearReturn: -0.12,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -0.42,
                            navSinceInceptionAnnualizedReturn: -0.33,
                            marketPriceQuarterlyYtdReturn: -0.12,
                            marketPriceOneYearReturn: -0.12,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -0.35,
                            marketPriceSinceInceptionAnnualizedReturn: -0.28,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 48.69,
                navPriceChange: 0.05,
                navPricePercentChange: 0.102796,
                closingPrice: 48.66,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'THYF',
            name: 'T. Rowe Price U.S. High Yield ETF',
            inceptionDate: '2022-10-25T04:00:00Z',
            grossExpenseRatio: 0.56,
            publicOfferingDate: '2022-10-26T04:00:00Z',
            netExpenseRatio: 0.56,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: null,
                            navOneYearReturn: null,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: 1.62,
                            navSinceInceptionAnnualizedReturn: null,
                            marketPriceQuarterlyYtdReturn: null,
                            marketPriceOneYearReturn: null,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: 2.28,
                            marketPriceSinceInceptionAnnualizedReturn: null,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 50.67,
                navPriceChange: -0.03,
                navPricePercentChange: -0.059172,
                closingPrice: 51.03,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TFLR',
            name: 'T. Rowe Price Floating Rate ETF',
            inceptionDate: '2022-11-16T05:00:00Z',
            grossExpenseRatio: 0.61,
            publicOfferingDate: '2022-11-17T05:00:00Z',
            netExpenseRatio: 0.61,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: null,
                            navOneYearReturn: null,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -0.24,
                            navSinceInceptionAnnualizedReturn: null,
                            marketPriceQuarterlyYtdReturn: null,
                            marketPriceOneYearReturn: null,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: 0.16,
                            marketPriceSinceInceptionAnnualizedReturn: null,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 50.23,
                navPriceChange: 0.04,
                navPricePercentChange: 0.079697,
                closingPrice: 50.38,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TAXE',
            name: 'Intermediate Municipal Income ETF',
            inceptionDate: '2020-08-04T04:00:00Z',
            grossExpenseRatio: 0, // 0.57,
            publicOfferingDate: '2020-08-05T04:00:00Z',
            netExpenseRatio: 0, // 0.57,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: '2022-12-31T00:00:00Z',
                    fundPerformance: [
                        {
                            performanceType: 'Net',
                            navQuarterlyYtdReturn: -37.82,
                            navOneYearReturn: -37.88,
                            navThreeYearReturn: null,
                            navFiveYearReturn: null,
                            navTenYearReturn: null,
                            navSinceInceptionReturn: -17.58,
                            navSinceInceptionAnnualizedReturn: -7.72,
                            marketPriceQuarterlyYtdReturn: -37.82,
                            marketPriceOneYearReturn: -37.82,
                            marketPriceThreeYearReturn: null,
                            marketPriceFiveYearReturn: null,
                            marketPriceTenYearReturn: null,
                            marketPriceSinceInceptionReturn: -17.5,
                            marketPriceSinceInceptionAnnualizedReturn: -7.68,
                            __typename: 'ETFPerformance'
                        }
                    ],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: '2023-04-04T00:00:00Z',
                navPrice: 24.03,
                navPriceChange: -0.03,
                navPricePercentChange: -0.124688,
                closingPrice: 24.03,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TCAF',
            name: 'T. Rowe Price Capital Appreciation Equity ETF',
            inceptionDate: '2022-12-01T05:00:00Z',
            grossExpenseRatio: 0.31,
            publicOfferingDate: '2022-12-02T05:00:00Z',
            netExpenseRatio: 0.31,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null,
                    fundPerformance: [],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: null,
                navPrice: null,
                navPriceChange: null,
                navPricePercentChange: null,
                closingPrice: null,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TGRT',
            name: 'T. Rowe Price Growth ETF',
            inceptionDate: '2022-11-22T05:00:00Z',
            grossExpenseRatio: 0.38,
            publicOfferingDate: '2022-11-22T05:00:00Z',
            netExpenseRatio: 0.38,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null,
                    fundPerformance: [],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: null,
                navPrice: null,
                navPriceChange: null,
                navPricePercentChange: null,
                closingPrice: null,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TVAL',
            name: 'T. Rowe Price Value ETF',
            inceptionDate: '2022-11-22T05:00:00Z',
            grossExpenseRatio: null,
            publicOfferingDate: '2022-11-23T05:00:00Z',
            netExpenseRatio: null,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null,
                    fundPerformance: [],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: null,
                navPrice: null,
                navPriceChange: null,
                navPricePercentChange: null,
                closingPrice: null,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TMSL',
            name: 'T. Rowe Price Small-Mid Cap ETF',
            inceptionDate: '2022-11-21T05:00:00Z',
            grossExpenseRatio: 0.55,
            publicOfferingDate: '2022-11-21T05:00:00Z',
            netExpenseRatio: 0.55,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null,
                    fundPerformance: [],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: null,
                navPrice: null,
                navPriceChange: null,
                navPricePercentChange: null,
                closingPrice: null,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        },
        {
            ticker: 'TOUS',
            name: 'T. Rowe Price International Equity ETF',
            inceptionDate: '2022-11-22T05:00:00Z',
            grossExpenseRatio: 0.5,
            publicOfferingDate: '2022-11-23T05:00:00Z',
            netExpenseRatio: 0.5,
            averageAnnualTotalReturns: {
                quarterly: {
                    asOfDate: null,
                    fundPerformance: [],
                    __typename: 'AverageAnnualTotalReturn'
                },
                __typename: 'AverageAnnualTotalReturns'
            },
            price: {
                asOfDate: null,
                navPrice: null,
                navPriceChange: null,
                navPricePercentChange: null,
                closingPrice: null,
                __typename: 'ETFPrice'
            },
            __typename: 'ExchangeTradedFund'
        }
    ]
};
